import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as _ from "lodash";
import React, { useState } from "react";
import {
  CustomerType,
  EffectFilterState,
  EffectsColumnsDataState,
} from "src/types";

interface Props {
  changeFilter: (name: string, value: unknown) => void;
  effectsFilter: EffectFilterState;
  effectsColumnsData: EffectsColumnsDataState["effectsColumnsData"];
}

const EffectFilter: React.FC<Props> = ({
  changeFilter,
  effectsFilter,
  effectsColumnsData,
}: Props) => {
  const [accordionExpanded, setAccordionExpanded] = useState(true);

  const handleAccordionChange = (
    event: React.ChangeEvent<{}>,
    expanded: boolean
  ): void => {
    setAccordionExpanded(expanded);
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    changeFilter(name, value);
  };

  return (
    <Accordion expanded={accordionExpanded} onChange={handleAccordionChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Effektfilter</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12} md={6}>
            <FormControl component="fieldset" margin="dense" fullWidth={true}>
              <FormLabel component="legend">Kundentyp</FormLabel>
              <RadioGroup
                name="customerType"
                value={effectsFilter.customerType}
                onChange={handleChange}
                row={true}
              >
                <FormControlLabel
                  value={CustomerType.PK}
                  control={<Radio />}
                  label="Privatkunde"
                />
                <FormControlLabel
                  value={CustomerType.GK}
                  control={<Radio />}
                  label="Gewerbekunde"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item={true} xs={12} md={6}>
            <FormControl margin="dense" fullWidth={true}>
              <FormLabel component="div">Effektkategorie</FormLabel>
              <TextField
                select={true}
                // label="Zeitraum"
                value={effectsFilter.columnName || ""}
                onChange={handleChange}
                margin="normal"
                name="columnName"
                variant="outlined"
                fullWidth={true}
              >
                {_.orderBy(effectsColumnsData, ["columnName"]).map((el, i) => (
                  <MenuItem key={i} value={el.columnName}>
                    {" "}
                    {el.columnName}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default EffectFilter;



// WEBPACK FOOTER //
// ./src/components/EffectFilter.tsx